import React, { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

import * as api from "@nens/threedi/openapi-client";

import { getV3Api } from "../../apiConfiguration";
import Duration from "../../components/Duration";
import { getExistingConstantRain } from "../../state/existingEvents";
import { getSimulationStatus } from "../../state/simulation";
import { menuExistingItemCardRow } from "../../styles/styleComposition";
import { simulationIdFromUrl } from "../../utils/apiUtils";
import { mPerSecondToMmPerHour } from "../../utils/conversions";
import menuExistingItemStyles from "../MenuExistingItemStyles.module.css";

import ExistingItemCard from "./ExistingItemCard";

const ExistingConstantRainEvent: React.FC<{
  rainEvent: api.ConstantRain;
}> = ({ rainEvent }) => {
  const simulationStatus = useSelector(getSimulationStatus);
  const simulationTime = simulationStatus.time;

  const onDelete = useCallback(async () => {
    const v3Api = getV3Api();
    if (rainEvent && rainEvent.id && rainEvent.simulation) {
      try {
        await v3Api.simulationsEventsRainConstantDelete({
          id: rainEvent.id,
          simulationPk: simulationIdFromUrl(rainEvent.simulation),
        });
      } catch (e) {
        // XXX.
      }
    }
  }, [rainEvent]);

  const onStop = useCallback(async () => {
    const v3Api = getV3Api();
    if (rainEvent && rainEvent.id && rainEvent.simulation) {
      try {
        await v3Api.simulationsEventsRainConstantPartialUpdate({
          id: rainEvent.id,
          simulationPk: simulationIdFromUrl(rainEvent.simulation),
          //@ts-ignore
          data: {
            duration: Math.max(simulationTime + 1 - rainEvent.offset, 1),
          },
        });
      } catch (e) {
        // XXX.
      }
    }
  }, [rainEvent, simulationTime]);

  return (
    <ExistingItemCard
      onDelete={onDelete}
      onStop={onStop}
      start={rainEvent.offset}
      end={rainEvent.duration ? rainEvent.offset + rainEvent.duration : undefined}
      controlType="editRain"
    >
      <div className={menuExistingItemCardRow}>
        <span>Type:</span>
        <span className={menuExistingItemStyles.ItemName}>Constant</span>
      </div>
      <div className={menuExistingItemCardRow}>
        <span>
          <FormattedMessage id="newRainMenu.intensity_label" defaultMessage="Intensity" />:
        </span>
        <span>
          {Math.round(mPerSecondToMmPerHour("value" in rainEvent ? rainEvent.value : 0))}{" "}
          {/* for now mm/h is not supported by api, but this is the most logical form */}
          {/* <span>{existingItem.units}</span> */}
          <FormattedMessage id="newRainMenu.intensity_unit_mm/h" defaultMessage="mm/h" />
        </span>
      </div>
      <div className={menuExistingItemCardRow}>
        <span>
          <FormattedMessage id="existingRainMenu.duration_label" defaultMessage="Duration" />:
        </span>
        <span>
          {rainEvent.duration === null ? "-" : <Duration duration={rainEvent.duration} />}
        </span>
      </div>
    </ExistingItemCard>
  );
};

const ExistingConstantRainEvents = () => {
  const existingConstantRainEvents = useSelector(getExistingConstantRain);

  return (
    <div>
      {existingConstantRainEvents.map((rainEvent) => (
        <ExistingConstantRainEvent rainEvent={rainEvent} key={rainEvent.id} />
      ))}
    </div>
  );
};

export default ExistingConstantRainEvents;
